document.addEventListener('DOMContentLoaded', function() {
    const promoInput = document.getElementById('buyer-seatsio-promo-code');
    const applyBtn = document.getElementById('buyer-seatsio-promo-apply');
    const removeBtn = document.getElementById('buyer-seatsio-promo-remove');
    const messageContainer = document.getElementById('buyer-seatsio-promo-message');

    function updateTotalPriceUI(detail) {
        const { selectedObjects, config, priceFormatter } = detail;
        const pricesBlock = document.querySelector('.buyer-seatsio-extended .prices');
        const helpText = document.querySelector('.buyer-seatsio-extended .help-text');
        if (!pricesBlock) return;

        const helper = window.seatsioHelper;

        if (!helper) return;

        let total = 0;
        selectedObjects.forEach(obj => {
            const categoryKey = helper.getCategoryKey(obj);
            const price = helper.findPriceByCategoryKey(categoryKey);
            if (price) {
                total += price;
            }
        });

    if (total === 0) {
        pricesBlock.style.display = 'none';
        if (helpText) helpText.style.display = 'block';
        return;
    }

    if (helpText) helpText.style.display = 'none';

    const formattedPrice = priceFormatter.format(total) + ' ' + config.currencySymbol;

    const priceValue = pricesBlock.querySelector('.price-value');
    if (priceValue) {
        priceValue.textContent = formattedPrice;
    }

    let finalTotal = total;
    const ticketsSumBlock = pricesBlock.querySelector('.tickets-sum');
    const marginBlock = pricesBlock.querySelector('.pay-system-margin');
    const oldPrice = pricesBlock.querySelector('.price-total .old-price');
    const finalPrice = pricesBlock.querySelector('.final-price');

    const marginValueEl = marginBlock?.querySelector('.margin-value');
    const marginPercent = parseInt(marginValueEl?.dataset.margin || 0);

    if (window.appliedPromoCode) {
        const promo = window.appliedPromoCode;
        let discountAmount = 0;
        if (promo.discountType === 1) { // ROUBLE
            discountAmount = promo.discountValue;
        } else if (promo.discountType === 2) { // PERCENT
            discountAmount = Math.floor(total * promo.discountValue / 100);
        }
        finalTotal = Math.max(0, total - discountAmount);

        if (oldPrice) {
            let totalWithMargin = total;
            if (marginPercent > 0) {
                totalWithMargin += Math.ceil(total * marginPercent / 100);
            }
            oldPrice.textContent = priceFormatter.format(totalWithMargin) + ' ' + config.currencySymbol;
            oldPrice.style.display = 'inline';
        }
    } else {
        if (oldPrice) {
            oldPrice.style.display = 'none';
        }
    }

    if (marginBlock) {
        if (marginPercent > 0) {
            const marginAmount = Math.ceil(finalTotal * marginPercent / 100);
            finalTotal += marginAmount;
            if (marginValueEl) {
                marginValueEl.textContent = priceFormatter.format(marginAmount) + ' ' + config.currencySymbol;
            }
            marginBlock.style.display = 'block';
        } else {
            marginBlock.style.display = 'none';
        }
    }

    if (finalPrice) {
        finalPrice.textContent = priceFormatter.format(finalTotal) + ' ' + config.currencySymbol;
    }

    if (helpText) {
        helpText.style.display = total > 0 ? 'none' : 'block';
    }

    if (ticketsSumBlock) {
        ticketsSumBlock.style.display = total > 0 ? 'block' : 'none';
    }

        pricesBlock.style.display = 'block';
    }

    document.addEventListener('seatsioTotalPriceUpdate', function(e) {
        updateTotalPriceUI(e.detail);
    });

    const ticketsBtns = document.querySelectorAll('.seatsio-tickets-btn');
    ticketsBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            if (window.seatsioHelper) {
                window.seatsioHelper.showChart();
            }
        });
    });

    const backBtn = document.querySelector('.buyer-seatsio-extended .back-button');
    if (backBtn) {
        backBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const scrollY = window.scrollY;

            document.dispatchEvent(new CustomEvent('seatsioGoBack'));

            window.scrollTo(0, scrollY);

            const mainContent = document.querySelector('.main-content');
            if (mainContent) {
                mainContent.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    const payBtn = document.querySelector('.seatsio-pay-button');
    if (payBtn) {
        payBtn.addEventListener('click', function () {
            if (!window.seatsioHelper) return;

            const buyerSeatsioExtended = document.querySelector('.buyer-seatsio-extended');
            if (buyerSeatsioExtended && parseInt(buyerSeatsioExtended.dataset.isGuest) === 1) {
                const inlineAuthHolder = document.querySelector('.inline-auth-holder');
                if (inlineAuthHolder) {
                    const form = inlineAuthHolder.querySelector('form');
                    if (form) {
                        form.setAttribute('data-showafter', '.buyer-seatsio-extended');
                    }
                    inlineAuthHolder.style.display = 'block';
                    buyerSeatsioExtended.style.display = 'none';

                    const eventInfoCard = document.querySelector('.event-info-aside__card');
                    if (eventInfoCard) {
                        eventInfoCard.style.display = 'none';
                    }
                    
                    const mainContent = document.querySelector('.main-content');
                    if (mainContent) {
                        mainContent.scrollIntoView({ behavior: 'smooth' });
                    }
                }

                return;
            }

            const config = window.seatsioConfig;
            const helper = window.seatsioHelper;

            if (!helper) {
                console.error('Seatsio helper not found');
                return;
            }

            const selectedObjects = helper.getSelectedObjects();
            const chart = helper.getChart();

            if (!config) {
                console.error('Seatsio config not found');
                return;
            }

            if (selectedObjects.size === 0) {
                alert('Пожалуйста, выберите хотя бы одно место');
                return;
            }

            const seats = [];
            selectedObjects.forEach((obj, id) => {
                const {row, seat} = helper.getSeatParts(obj);
                seats.push({
                    id: id,
                    label: obj.label,
                    row: row,
                    seat: seat,
                    categoryKey: helper.getCategoryKey(obj)
                });
            });

            payBtn.disabled = true;
            payBtn.textContent = 'Обработка...';

            fetch('/seatsio-purchase/create-order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
                },
                body: JSON.stringify({
                    lectureId: config.lectureId,
                    seats: seats,
                    holdToken: chart.holdToken,
                    promoCode: window.appliedPromoCode ? window.appliedPromoCode.code : null
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    } else {
                        location.reload();
                    }
                } else {
                    alert(data.message || 'Произошла ошибка при создании заказа');
                    payBtn.disabled = false;
                    payBtn.textContent = 'Оплатить';
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Произошла ошибка при создании заказа');
                payBtn.disabled = false;
                payBtn.textContent = 'Оплатить';
            });
        });
    }

    document.addEventListener('promoCodeApplied', function(e) {
        let detail = e.detail;

        if (detail && !detail.config) {
            const config = window.seatsioConfig;
            const helper = window.seatsioHelper;
            
            if (helper && config) {
                detail = {
                    config: config,
                    selectedObjects: helper.getSelectedObjects(),
                    priceFormatter: helper.getPriceFormatter()
                };
            }
        }

        if (detail && detail.config) {
            updateTotalPriceUI({
                selectedObjects: detail.selectedObjects,
                config: detail.config,
                priceFormatter: detail.priceFormatter
            });
        }
    });

    document.addEventListener('promoCodeRemoved', function() {
        const config = window.seatsioConfig;
        const helper = window.seatsioHelper;

        if (helper && config) {
            const selectedObjects = helper.getSelectedObjects();
            const priceFormatter = helper.getPriceFormatter();
            
            updateTotalPriceUI({
                selectedObjects: selectedObjects,
                config: config,
                priceFormatter: priceFormatter
            });
        }
    });

    if (applyBtn) {
        applyBtn.addEventListener('click', function() {
            const code = promoInput.value.trim();
            const lectureId = applyBtn.dataset.lectureId;
            
            if (!code) return;

            applyBtn.disabled = true;
            messageContainer.className = 'buyer-seatsio-promo-message';
            messageContainer.textContent = '';

            fetch('/seatsio-purchase/validate-promo-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
                },
                body: `promoCode=${encodeURIComponent(code)}&lectureId=${lectureId}`
            })
            .then(response => response.json())
            .then(data => {
                applyBtn.disabled = false;
                if (data.success) {
                    promoInput.classList.add('promoCode-input-active');
                    promoInput.setAttribute('readonly', 'readonly');
                    
                    applyBtn.style.display = 'none';
                    if (removeBtn) removeBtn.style.display = 'inline-block';

                    window.appliedPromoCode = {
                        code: code,
                        discountValue: data.discountValue,
                        discountType: data.discountType
                    };

                    const event = new CustomEvent('promoCodeApplied', { detail: window.appliedPromoCode });
                    document.dispatchEvent(event);
                } else {
                    messageContainer.textContent = data.message || 'Неверный промокод';
                    messageContainer.classList.add('error');
                    window.appliedPromoCode = null;
                    const event = new CustomEvent('promoCodeRemoved');
                    document.dispatchEvent(event);
                }
            })
            .catch(error => {
                applyBtn.disabled = false;
                messageContainer.textContent = 'Ошибка связи с сервером';
                messageContainer.classList.add('error');
            });
        });
    }

    if (removeBtn) {
        removeBtn.addEventListener('click', function() {
            promoInput.value = '';
            promoInput.classList.remove('promoCode-input-active');
            promoInput.removeAttribute('readonly');
            
            removeBtn.style.display = 'none';
            applyBtn.style.display = 'inline-block';
            
            messageContainer.textContent = '';
            messageContainer.className = 'buyer-seatsio-promo-message';
            
            window.appliedPromoCode = null;
            
            const event = new CustomEvent('promoCodeRemoved');
            document.dispatchEvent(event);
        });
    }
});
